import React from "react";

export default function StaffToolbar({ searchTerm, onSearchChange, statusFilter, onStatusChange, canEdit, onAdd }) {
  return (
    <div className="bg-white rounded-lg shadow-sm border p-4 mb-5">
      <div className="flex flex-col md:flex-row gap-3 md:items-center md:justify-between">
        <div className="flex flex-col sm:flex-row gap-3 flex-1">
          <input
            type="text"
            value={searchTerm}
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder="Search by name, email, mobile or role..."
            className="border rounded px-3 py-2 w-full sm:max-w-xl"
          />
          <select
            value={statusFilter}
            onChange={(event) => onStatusChange(event.target.value)}
            className="border rounded px-3 py-2 bg-white sm:w-44"
          >
            <option value="all">All staff</option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>
        {canEdit && (
          <button onClick={onAdd} className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 whitespace-nowrap">
            + Add Staff
          </button>
        )}
      </div>
    </div>
  );
}
